import { useState, useEffect } from 'react';
 

function VideoShowcase() {
  const [isMobile, setIsMobile] = useState(false);
  // const [isVideoLoaded, setIsVideoLoaded] = useState(false);


   // סגנון משותף לתמונה ולוידאו
  const sharedMediaStyle = {
    width: '100%',
    maxWidth: '1200px',
    maxHeight: '700px',
    height: 'auto',
    objectFit: 'cover',
    display: 'block',
  };


  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1010);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (isMobile) return    <div style={{ position: 'relative', maxHeight: '700px', width: '100%' ,marginBottom:"10px" ,marginTop:"10px"}}>
      {/* {!isVideoLoaded && ( <img src='./videos/preloader_700px_1.jpg' alt="loading"  style={sharedMediaStyle}   />  )} */}
      <video
        autoPlay
        loop
        muted
        playsInline
          preload="auto"
        // onLoadedData={() => setIsVideoLoaded(true)}
       style={sharedMediaStyle}
           poster='./hero/preloader_500px_1.jpg'
      >

        <source src="/hero/render-kerk-site-movie_888X500_handbrake.mp4"   type="video/mp4" />
         {/* <source src="/hero/render-kerk-site-movie_888X500_handbrake.webm"  type="video/webm" /> */}

        הדפדפן שלך לא תומך בוידאו.
      </video>
    </div>;
        
  return (
    <div style={{ position: 'relative', maxHeight: '700px', width: '100%'  }}>
      {/* {!isVideoLoaded && ( <img src='./videos/preloader_700px_1.jpg' alt="loading"  style={sharedMediaStyle}   />  )} */}

      <video
        autoPlay
        loop
        muted
        playsInline
          preload="auto"
        // onLoadedData={() => setIsVideoLoaded(true)}
       style={sharedMediaStyle}
       poster='./hero/preloader_700px_1.jpg'
      >
        {/* <source src="/hero/render-kerk-site-movie_1244X700_handbrake.webm"  type="video/webm" /> */}
        <source src="/hero/render-kerk-site-movie_1244X700_handbrake.mp4"  type="video/mp4" />
        הדפדפן שלך לא תומך בוידאו.
      </video>
    </div>





  );









  
}

export default VideoShowcase;
